import { Card, CardContent, Grid, Paper, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useFetchFacturaCats } from '../../../hooks/useFetchFacturaCats';
import { DatosFactura } from './DatosFactura';
import { SelectCustom } from './SelectCustom';

export const GroupRequiereInvoiceGlobal = (props) => {

    const [invoiceValues, setInvoiceValues] = useState({
        
        requiereFactura: "No",
        factExtranjero: "",
        factExtPais: "",
        factExtNombre: "",
        factExtConcepto: "",
        factExtUsoCFDI: "",
        factNombre: "",
        factRFC: "",
        factCP: "",
        factUsoCFDI: "",
        factRegimenFiscal: "",
    });
    const { 
        factExtNombre,
        factExtConcepto,
    } = invoiceValues;

    // state para saber si requiere factura
    const [requireInvoice, setRequireInvoice] = useState({
        value: 'No'
    });
    const handleRequireInvoiceChange = ({ target }) => {
        const { value, name } = target;

        setRequireInvoice({ value: value });

        setInvoiceValues({
            ...invoiceValues,
            [name]: value,
        })
 
        // Ejecuta la funcion que recibe en -parenCallback- desde el parent component
        props.parentCallback(target);
    }


    // Se ejecuta cada que un input para los datos de facturacion cambia
    const handleInputInvoiceChange = ({ target }) => {
        const { value, name } = target;

        setInvoiceValues({
            ...invoiceValues,
            [name]: value,
        })

        props.parentCallback(target);
    }


    // Se ejecuta al cargarse la pagina y de acuerdo al _loading_ se muestra/oculta el dialog de "Cargando inf..."
    const { dataPaises } = useFetchFacturaCats();

    // console.log({invoiceValues});

  return (
    <>
        <Grid container spacing={1} sx={{ p: 1, m: 0 }} >

            {/* Requiere factura */}
            <SelectCustom 
                parentCallback={ handleRequireInvoiceChange }
                name={"requiereFactura"}
                label={"¿Requiere factura? | Need invoice?"}
                variant={"standard"}
                options={[
                    {value:'No', label:'No'},
                    {value:'Si', label:'Si, para un contribuyente mexicano'},
                    {value:'SiExt', label:'Si, para el extranjero'},
                ]}
                required
            />

            {/* Factura mexicana */}
            <Grid container 
                spacing={1} 
                sx={{ display:((requireInvoice.value === 'Si') ? 'flex' : 'none') }} 
            >
                <Grid container spacing={2} sx={{ p: 2, mt: 0 }} >
                    <Grid item xs={12}>
                        <Paper elevation={2} >
                            <Card variant="outlined" >
                                <CardContent>
                                    <DatosFactura parentCallback={handleInputInvoiceChange} />
                                </CardContent>
                            </Card>
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>

            {/* Factura extranjera */}
            <Grid container 
                spacing={1} 
                sx={{ display:((requireInvoice.value === 'SiExt') ? 'flex' : 'none') }} 
            >
                <Grid container spacing={2} sx={{ p: 2, mt: 0 }} >
                    <Grid item xs={12}>
                    <Paper elevation={2} >
                    <Card variant="outlined" >
                    <CardContent>
                        {/* Elegir pais */}
                        <SelectCustom 
                            parentCallback={handleInputInvoiceChange}
                            name={"factExtPais"}
                            label={"Pais | Country"}
                            variant={"standard"}
                            options={
                                dataPaises.map(({ value, label }) => (
                                    {value:value, label:label}
                                ))
                            }
                            required
                        />
                        {/* A nombre de */}
                        <Grid item xs={12}>
                            <TextField 
                                fullWidth
                                label={'Factura a nombre | Invoice to name *'}
                                id={'factExtNombre'}
                                name={'factExtNombre'}
                                size='small'
                                value={factExtNombre}
                                variant={'standard'}
                                onChange={handleInputInvoiceChange}
                            />
                        </Grid>
                        {/* A nombre de */}
                        <Grid item xs={12}>
                            <TextField 
                                fullWidth
                                label={'Concepto | Concept *'}
                                id={'factExtConcepto'}
                                name={'factExtConcepto'}
                                size='small'
                                value={factExtConcepto}
                                variant={'standard'}
                                onChange={handleInputInvoiceChange}
                            />
                        </Grid>
                    </CardContent>
                    </Card>
                    </Paper>
                    </Grid>
                </Grid>
                
            </Grid>


        </Grid>
    </>
  )
}
